import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { LwField } from '@/components/lw';
import type { RecruitmentFormValues } from './validations';

interface PersonalInfoSectionProps {
  form: UseFormReturn<RecruitmentFormValues>;
  savedEmail?: boolean;
}

export const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({ form, savedEmail = false }) => {
  const { register, formState: { errors }, setValue } = form;

  // Format phone number as user types: (XXX)-XXX-XXXX
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const cleaned = value.replace(/\D/g, '');

    let formatted = cleaned;
    if (cleaned.length >= 6) {
      formatted = `(${cleaned.slice(0, 3)})-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    } else if (cleaned.length >= 3) {
      formatted = `(${cleaned.slice(0, 3)})-${cleaned.slice(3)}`;
    }

    setValue('phone', formatted, { shouldValidate: true });
  };

  return (
    <>
      <div>
        <div className="dw-sec-title">Personal information</div>
        <div className="dw-grid">
          <LwField label={<>Legal first name <span className="req">*</span></>} htmlFor="firstName" error={errors.firstName?.message}>
            <input id="firstName" className={errors.firstName ? 'invalid' : ''} {...register('firstName')} placeholder="John" />
          </LwField>
          <LwField label={<>Legal last name <span className="req">*</span></>} htmlFor="lastName" error={errors.lastName?.message}>
            <input id="lastName" className={errors.lastName ? 'invalid' : ''} {...register('lastName')} placeholder="Doe" />
          </LwField>
          <LwField span="full" label="Preferred first name" htmlFor="preferredFirstName" error={errors.preferredFirstName?.message}>
            <input
              id="preferredFirstName"
              className={errors.preferredFirstName ? 'invalid' : ''}
              {...register('preferredFirstName')}
              placeholder="If different from legal name"
            />
          </LwField>
          <LwField span="2" label={<>Email <span className="req">*</span></>} htmlFor="email" error={errors.email?.message}>
            <input id="email" type="email" readOnly={savedEmail} className={errors.email ? 'invalid' : ''} {...register('email')} placeholder="john.doe@example.com" />
          </LwField>
          <LwField label={<>Phone <span className="req">*</span></>} htmlFor="phone" error={errors.phone?.message}>
            <input
              id="phone"
              type="tel"
              className={errors.phone ? 'invalid' : ''}
              {...register('phone', { onChange: handlePhoneChange })}
              placeholder="(555)-123-4567"
            />
          </LwField>
          <LwField label="Date of birth" htmlFor="dateOfBirth" error={errors.dateOfBirth?.message}>
            <input id="dateOfBirth" type="date" className={errors.dateOfBirth ? 'invalid' : ''} {...register('dateOfBirth')} />
          </LwField>
        </div>
      </div>

      <div>
        <div className="dw-sec-title">Mailing address</div>
        <div className="dw-grid">
          <LwField span="full" label="Street address" htmlFor="mailingStreetAddress" error={errors.mailingStreetAddress?.message}>
            <input
              id="mailingStreetAddress"
              className={errors.mailingStreetAddress ? 'invalid' : ''}
              {...register('mailingStreetAddress')}
              placeholder="123 Main Street"
            />
          </LwField>
          <LwField label="City" htmlFor="mailingCity" error={errors.mailingCity?.message}>
            <input id="mailingCity" className={errors.mailingCity ? 'invalid' : ''} {...register('mailingCity')} placeholder="Los Angeles" />
          </LwField>
          <LwField label="State" htmlFor="mailingState" error={errors.mailingState?.message}>
            <input id="mailingState" className={errors.mailingState ? 'invalid' : ''} {...register('mailingState')} placeholder="CA" maxLength={2} />
          </LwField>
          <LwField label="ZIP code" htmlFor="mailingZip" error={errors.mailingZip?.message}>
            <input id="mailingZip" className={errors.mailingZip ? 'invalid' : ''} {...register('mailingZip')} placeholder="90001" />
          </LwField>
        </div>
      </div>
    </>
  );
};
